export default "__VITE_ASSET__C$98Kavm__"